import React from "react";

export default function SectionHeading({ eyebrow, title, sub, align = "left", className = "" }) {
    const alignment = align === "center" ? "text-center mx-auto" : "text-left";
    return (
        <div className={`max-w-3xl ${alignment} ${className}`}>
            {eyebrow && (
                <p className="text-xs uppercase tracking-[0.3em] text-brand-secondary font-bold mb-4">
                    {eyebrow}
                </p>
            )}
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-brand-primary leading-[1.05] font-medium tracking-tight">
                {title}
            </h2>
            {sub && (
                <p className="mt-5 text-base sm:text-lg text-brand-textMuted leading-relaxed max-w-2xl">
                    {sub}
                </p>
            )}
        </div>
    );
}
